import { Box, Divider, List, Paper } from '@mui/material';
import { LuFileClock, LuLoader, LuMail, LuPhone, LuPlane } from 'react-icons/lu';
import { WsColors } from 'wisestep-base';

import {
  JobTitleFilter,
  CreatedBwDatesFilter,
  CurrentEmployersFilter,
  JobTypeFilter,
  LanguagesFilter,
  NoticePeriod,
  PreviousEmployersFilter,
  SalaryRangeFilter,
  SourceFilter,
  TagsFilter,
  TotalExperienceFilter,
} from '../../../../components/filters/components';
import {
  workAuthorization,
  contactPreferences,
  jobPreferences,
  candidateStatus,
} from '../../../../components/filters/components/AdvanceFilterHelper';
import CheckboxListFilter from '../../../../components/filters/components/CheckboxListFilter';
import AdvancedFiltersHeader from '../../../../utils/AdvancedFiltersHeader';

const JobTalentPoolAdvancedFilters = () => (
  <Paper>
    <Box>
      <AdvancedFiltersHeader />
      <Divider />
      <List>
        <JobTitleFilter name="jobTitles" title="Job Title(s)" showAccordionIcon={true} />
        <CreatedBwDatesFilter
          name="createBWDates.fromDateName"
          name1="createBWDates.toDateName"
          showAccordionIcon={true}
        />
        <CheckboxListFilter
          name="workAuthorization"
          options={workAuthorization}
          title="Work Authorization"
          startIcon={<LuPlane color={WsColors.TertiaryShades800} />}
        />
        <SourceFilter name="source" showAccordionIcon={true} />
        <CheckboxListFilter
          name="commPreference"
          options={contactPreferences}
          title="Communication Preference"
          startIcon={<LuMail color={WsColors.TertiaryShades800} />}
        />
        <CurrentEmployersFilter name="currentEmployers" showAccordionIcon={true} />
        <PreviousEmployersFilter name="previousEmployers" showAccordionIcon={true} />
        <CheckboxListFilter
          name="contactAvailability"
          options={contactPreferences}
          title="Contact Availability"
          startIcon={<LuPhone color={WsColors.TertiaryShades800} />}
        />
        <SalaryRangeFilter showAccordionIcon={true} />
        <NoticePeriod name="noticePeriod" showAccordionIcon={true} />
        <LanguagesFilter name="languages" showAccordionIcon={true} />
        <JobTypeFilter name="jobType" showAccordionIcon={true} />
        <CheckboxListFilter
          name="jobPreference"
          options={jobPreferences}
          title="Job Preference"
          startIcon={<LuFileClock color={WsColors.TertiaryShades800} />}
        />
        <TotalExperienceFilter />
        <CheckboxListFilter
          name="candidateStatus"
          options={candidateStatus}
          title="Status"
          startIcon={<LuLoader color={WsColors.TertiaryShades800} />}
        />
        <TagsFilter name="tags" showAccordionIcon={true} />
      </List>
    </Box>
  </Paper>
);

export default JobTalentPoolAdvancedFilters;
